<template>
  <div
    class="position-relative"
    @click.stop="handleOpen"
    v-click-outside="handleCloseInDesktop"
  >
    <slot>
      <span :class="`cursor--pointer ${nameClass}`">
        {{ userData.fullName }}
      </span>
    </slot>
    <ProfileBoxPopup
      :show="isVisible && !disabled"
      :userData="userData"
      primaryKey="personCode"
      :extraPersonParams="{ parvandehCode: userData.parvandehCode }"
      :showChangeInfo="false"
      :showLogout="false"
      :hasVersion="false"
      :duration="100"
      transitionName="slide-y-up-transition"
      :deskTopPopupClass="deskTopPopupClass"
      :profileModalClass="profileModalClass"
      @setShow="handleClose"
    />
  </div>
</template>
<script>
import { ref, computed } from "vue";
import ProfileBoxPopup from "./ProfileBoxPopup.vue";
import { checkScreenDevice, generateUserData } from "@/shared/utils";

export default {
  components: { ProfileBoxPopup },
  props: {
    data: {
      type: Object,
      default: null,
    },
    deskTopPopupClass: {
      type: String,
      default: "top-304",
    },
    profileModalClass: {
      type: String,
      default: "bottom-0",
    },
    nameClass: {
      type: String,
      default: "color-complementary-300",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isVisible = ref(false);
    const handleOpen = () => (isVisible.value = true);
    const handleCloseInDesktop = () => {
      if (checkScreenDevice(["desktop"])) {
        isVisible.value = false;
      }
    };
    const handleClose = () => (isVisible.value = false);

    const userData = computed(() => generateUserData(props.data));

    return {
      isVisible,
      handleOpen,
      handleClose,
      userData,
      handleCloseInDesktop,
    };
  },
};
</script>
